module.exports = __webpack_public_path__ + "img/gh.4ebd0391.svg";